export default {
  test: 'widget test',
};
